import React from 'react'

export default function MarketbreadthData(props) {
    const getAllData = props.getTodayMarketData;
    return (
        <>
            {getAllData ? <>
                <table className="table table-bordered">
                    <thead>
                        <tr className="header-row changefont">
                            <th className="indexname" size="3">Sectors</th>
                            <th className="ltp" size="3">ADV/DEC</th>
                            <th className="change" size="3">%UP Stocks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getAllData.map(item => (
                            <tr key={item.id}>
                                <td>{item.sector_name} ({item.totalVal}) </td>
                                <td className="  max-100"  >
                                    <div className="marketwidth" style={{ 'background': item.background }} ></div>
                                    <div className="">{item.getadvRec} <label style={{ 'float': 'right' }}> {item.getdecRec}</label></div>
                                </td>
                                <td >{item.upstocks} %</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
                : ''}
        </>
    )
}
